import { render, staticRenderFns } from "./FormBuilderOptionTabWindow.vue?vue&type=template&id=c2ae24c2&scoped=true&"
import script from "./FormBuilderOptionTabWindow.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderOptionTabWindow.vue?vue&type=script&lang=ts&"
import style0 from "./FormBuilderOptionTabWindow.vue?vue&type=style&index=0&id=c2ae24c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ae24c2",
  null
  
)

export default component.exports